module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_41.dot-d836f052c97e63a9893c1df21c1e1eb3.svg";